import { BaseModel } from './base.model';
import { CandidateOnlinetestModel } from './candidate-onlinetest.model';
import { Deserializable } from './deserializable';
import { SALUTATIONS } from '../constants';

export type CandidateResultType = {
  recommendation: {
    id: number,
    name: string
  },
  values: {
    [key: number]: {
      value: number,
      name: {
        [key: number]: string
      }
    }
  }
};

export class CandidateModel extends BaseModel implements Deserializable {

  // columns
  gender: string;
  firstname: string;
  lastname: string;
  email: string;
  phone: string;
  mobile: string;
  directlink: string;
  hashed_id: any; // tslint:disable-line: variable-name
  invited_at: any; // tslint:disable-line: variable-name

  result?: CandidateResultType;

  // relations
  onlinetests: Array<any>;

  deserialize(input: any): this {
    Object.assign(this, input);
    // onlinetests
    let onlinetests = null;
    if (this.onlinetests !== null && this.onlinetests !== undefined) {
      onlinetests = [];
      this.onlinetests.forEach((onlinetest: CandidateOnlinetestModel) => {
        onlinetests.push(new CandidateOnlinetestModel().deserialize(onlinetest));
      });
    }
    this.onlinetests = onlinetests;
    return this;
  }

  get fullname(): string {
    return (this.firstname || '') + ' ' + (this.lastname || '');
  }

  get recommendation(): string | null {
    return this.result?.recommendation?.name || null;
  }

  getSalutation(): string {
    return SALUTATIONS[this.gender];
  }

}
